import { getCommentListApi } from '@/server'
import type { CommentResponse, CommonType } from '@/server/types'
import { usePagination } from '@/composables/usePagination'

export function logicComment(dataType: CommonType, id: string | number = -1) {
  const data = ref<CommentResponse[]>([])
  const pagination = usePagination({
    type: 'up',
    request: params => getCommentListApi(dataType, { ...params, id }),
  })

  async function getCommentList() {
    if (String(id) === '-1' || !id)
      return

    const { list = [] } = (await pagination.loadPaginationData()) || {}

    if (!list?.length)
      return
    data.value.push(...list)
  }

  return {
    data,
    state: computed(() => pagination.pagination.status),
    pagination,
    getCommentList,
  }
}
